export default "__VITE_ASSET__u7_UBcEa__"